/**
 * Submit-on-change filter forms.
 *
 * Shared by the careers listing (.kc-filters, KWB-65) and the News & PR archive
 * (.archive-filters, KWB-82). Both are plain GET forms that work fully without
 * this file — the submit button is real and the filtered state is a real URL.
 * All this adds is submit-on-change, which is what both designs imply.
 *
 * The button is hidden by CSS only once this script has flagged the document,
 * so a JS failure leaves a usable form rather than a dead one. That is why the
 * flag is set here and the hiding lives in the stylesheets.
 */
(function () {
  "use strict";

  var FORMS = [
    { selector: ".kc-filters", flag: "js-careers-filters" },
    { selector: ".archive-filters", flag: "js-archive-filters" },
  ];

  // Sort disclosure (KWB-82). The options are links, so this only opens and
  // closes the panel — with the script absent the panel stays shut, which is
  // why the native select is rendered alongside it and shown below $bm__lg.
  document.querySelectorAll("[data-archive-sort]").forEach(function (sort) {
    var toggle = sort.querySelector(".archive-sort__toggle");

    if (!toggle) return;

    function close() {
      sort.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    }

    toggle.addEventListener("click", function (event) {
      event.stopPropagation();
      var open = sort.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });

    document.addEventListener("click", function (event) {
      if (!sort.contains(event.target)) close();
    });

    sort.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      close();
      toggle.focus();
    });
  });

  FORMS.forEach(function (config) {
    var forms = document.querySelectorAll(config.selector);

    if (!forms.length) return;

    document.documentElement.classList.add(config.flag);

    forms.forEach(function (form) {
      // Anchor target for the post-submit reload (UAT post-launch): without a
      // fragment the GET submit lands back at the top of the page, above the
      // results. The id must exist at load time on the DESTINATION page too —
      // the browser retries the fragment scroll until the document finishes
      // loading — which is why it is set here and not in the change handler.
      // (The careers markup comes from the kambi-careers plugin, id-less.)
      var target = form.closest("section") || form;
      if (!target.id) target.id = "filters";

      form.addEventListener("change", function (event) {
        if (event.target.tagName !== "SELECT") return;

        // Drop the paged segment: filtering to a smaller result set while on
        // page 3 would otherwise land the visitor on an empty page.
        var action = form.getAttribute("action") || window.location.pathname;
        action = action.replace(/#.*$/, "").replace(/page\/\d+\/?$/, "");

        form.setAttribute("action", action + "#" + target.id);
        form.submit();
      });
    });
  });
})();
